'use strict';

export default (API) => ({
    establishment: {
        getAll: () => {
            const request = API.http.get('/v3/establishments', null);
            return API.handleError(request);
        },

        getAllWithSettings: () => {
            const request = API.http.get('/v3/establishments?settings=true', null);
            return API.handleError(request);
        },

        get: (establishmentId) => {
            const url = 'v3/establishments/' + establishmentId + '?settings=false';
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getWithSettings: (establishmentId) => {
            const url = 'v3/establishments/' + establishmentId + '?settings=true';
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getDetailedUsages: (headOffice, moduleId, dateStart = null, dateStop = null) => {
            let url = `v3/establishments/usage?headOffice=${headOffice}&module=${moduleId}`;
            if (dateStart) url += `&dateStart=${dateStart}`;
            if (dateStop) url += `&dateStop=${dateStop}`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getResourceOrders: (establishmentId) => {
            let url = `v3/establishments/${establishmentId}/resourceOrders`;

            const request = API.http.get(url);
            return API.handleError(request);
        },

        create: (params, withSettings) => {
            const url = 'v3/establishments' + (withSettings ? '?settings=true' : '');
            const request = API.http.post(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },

        update: (establishmentId, params, withSettings) => {
            const request = API.http.put('v3/establishments/' + establishmentId + (withSettings ? '?settings=true' : ''), params);
            return API.handleError(request);
        },

        updateStatus: (establishmentId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/status';
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },

        delete: (establishmentId) => {
            const url = 'v3/establishments/' + establishmentId;
            const request = API.http.delete(url);
            return API.handleError(request);
        },

        updateSettings: (establishmentId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/settings';
            if (!Array.isArray(params)) {
                params = [params];
            }
            const request = API.http.put(url, params);
            return API.handleError(request);
        },

        uploadLogo: (establishmentId, file, logoType) => {
            const url = 'v3/establishments/' + establishmentId + '/settings/logo?logoType=' + logoType;
            const params = new FormData();
            params.append('logo', file, file.name);

            const request = API.http.post(url, params, { headers: { 'Content-Type': 'multipart/form-data' } });
            return API.handleError(request);
        },

        deleteLogo: (establishmentId, logoType) => {
            const url = 'v3/establishments/' + establishmentId + '/settings/logo?logoType=' + logoType;
            const request = API.http.delete(url, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },

        getApprovedEstablishmentMetadataForEstablishment: (establishmentId) => {
            const url = `v3/establishments/${establishmentId}/metadata/approved`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getAllEstablishmentMetadataForEstablishment: (establishmentId) => {
            const url = `v3/establishments/${establishmentId}/metadata`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getEstablishmentMetadataForEstablishment: (establishmentId, establishmentMetadataId) => {
            const url = `v3/establishments/${establishmentId}/metadata/${establishmentMetadataId}`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        createEstablishmentMetadata: (establishmentId, params) => {
            const url = `v3/establishments/${establishmentId}/metadata`;
            const request = API.http.post(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },

        updateEstablishmentMetadata: (establishmentId, establishmentMetadataId, params) => {
            const url = `v3/establishments/${establishmentId}/metadata/${establishmentMetadataId}`;
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },

        createBulkImport: (file, basicInformation) => {
            const url = `v3/establishments/${basicInformation.establishment}/appointments/bulkImport`;
            let params = new FormData();
            params.append('csvFile', file, file.name);
            params.append('establishmentId', basicInformation.establishment);
            params.append('establishmentServiceTemplateId', basicInformation.service);
            params.append('resourceId', basicInformation.resource);
            params.append('placeId', basicInformation.place);
            params.append('date', basicInformation.date);

            const request = API.http.post(url, params, { headers: { 'Content-Type': 'multipart/form-data' } });
            return API.handleError(request);
        }
    },
});
